import React from "react";
import { Col, Grid, Panel, Row } from "react-bootstrap";
import { ReadonlyInput } from "../../common/Inputs";

const Total = ({ Count, Amount, DeliveryAmount, AverageBill }) => {
    if (!Count && !Amount)
        return null;

    return <Panel>
        <Panel.Heading>Аналитика</Panel.Heading>
        <Panel.Body>
            <Grid fluid={true}>
                <Row style={{ paddingBottom: '10px' }}>
                    <Col lg={6}><ReadonlyInput value={format(AverageBill)} label='Средний чек' /></Col>
                    <Col lg={6}><ReadonlyInput value={format(Count)} label='Количество заказов' /></Col>
                </Row>
                <Row>
                    <Col lg={6}><ReadonlyInput value={format(Amount)} label='Итоговая сумма заказов' /></Col>
                    <Col lg={6}><ReadonlyInput value={format(DeliveryAmount)} label='Сумма на логистику' /></Col>
                </Row>
            </Grid>
        </Panel.Body>
    </Panel>
}

const format = val => val === null || val === undefined ? '---' : val;

export default Total;


// WEBPACK FOOTER //
// ./src/components/analytics/orders/Total.jsx